import { defineStore } from "pinia";
import _ from 'lodash';

import type { IProgramTermVm } from "@/types";

export const useProgramTermStore = defineStore({
    id: "useProgramTermStore",
    state: () => ({
        programTerms: [] as Array<IProgramTermVm>,
        isLoadingProgramTerms: false
    }),
    getters: {},
    actions: {
        async loadProgramTerms() {
            if(this.programTerms && this.programTerms.length > 0) return

            if(this.isLoadingProgramTerms) {
                return;    
            }

            this.isLoadingProgramTerms = true;
            try {
                var url = `/api/Participation/GetProgramTerms`;
                const response = await this.axiosFactory.withoutToken().get(url);
                this.programTerms = response.data.data;
            } catch (error: any) {
                console.log(error.response)
            } finally {
                this.isLoadingProgramTerms = false;
            }
        },
    }
});
